import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ConnectedCompanyIntegrations,
  connectedCompanyIntegrationsSchema,
} from '../../../models/connected-company-integrations.schema';
import { decodeZodData } from '../../../models/handle-schema';
import { getFunctionUrl } from '../../../utils/get-function-url';

@Injectable({ providedIn: 'root' })
export class GetConnectedCompanyIntegrationsService {
  private readonly http = inject(HttpClient);
  private readonly url = getFunctionUrl(environment.urls.functions.v2, 'integrationsapiv2');

  get(): Observable<ConnectedCompanyIntegrations> {
    return this.http.get<unknown>(`${ this.url }/connected`).pipe(
      decodeZodData(connectedCompanyIntegrationsSchema),
    );
  }
}
